var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-toggler",on:{"click":_vm.toggle}},[_vm._t("toggler",function(){return [_c('button',[_vm._v("Toggle")])]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }